// /@/types/constants.ts
import {
  FundOutlined,
  FundProjectionScreenOutlined,
  PictureOutlined,
  TeamOutlined,
  ProfileOutlined,
  AppstoreAddOutlined,
  MenuFoldOutlined,
  UsergroupAddOutlined,
  SnippetsOutlined,
  UserOutlined,
  ClusterOutlined,
  ExportOutlined,
  MenuOutlined,
  AppstoreOutlined
} from '@ant-design/icons-vue'
import { ELocalStorageKey, ERouterName } from './index'

export const SCENARIO_OPTIONS = [
  {
    key: 1,
    label: ERouterName.SCENARIO_PLAN_NAME,
    path: `/${ERouterName.SCENARIO_PLAN}`,
    icon: MenuFoldOutlined
  },
  {
    key: 2,
    label: ERouterName.SCENARIO_ICON_NAME,
    path: `/${ERouterName.SCENARIO_ICON}`,
    icon: AppstoreAddOutlined
  }
]

// 导航选项
export const NAV_OPTIONS = [
  {
    key: 1,
    label: ERouterName.WORKSPACE_NAME,
    path: `/${ERouterName.WORKSPACE}`,
    icon: FundProjectionScreenOutlined
  },
  {
    key: 2,
    label: ERouterName.DATA_UI_NAME,
    path: `/${ERouterName.DATA_UI}`,
    icon: FundOutlined
  },
  {
    key: 3,
    label: ERouterName.MEDIA_NAME,
    path: `/${ERouterName.MEDIA}`,
    icon: PictureOutlined
  },
  {
    key: 4,
    label: ERouterName.SCENARIO_NAME,
    path: `/${ERouterName.SCENARIO}`,
    icon: UsergroupAddOutlined
  }
]

// 系统菜单项配置（不包含处理函数）
export const SYSTEM_MENU_CONFIG = [
  {
    key: 'user',
    icon: UserOutlined,
    text: '个人中心',
    route: ERouterName.USER
  },
  {
    key: 'member',
    icon: TeamOutlined,
    text: ERouterName.MEMBERS_NAME,
    route: ERouterName.MEMBERS
  },
  {
    key: 'org',
    icon: ClusterOutlined,
    text: '项目管理',
    route: ERouterName.ORG
  },
  {
    key: 'log',
    icon: SnippetsOutlined,
    text: '指令日志',
    route: ERouterName.INST_LOG
  },
  {
    key: 'firemware',
    icon: AppstoreOutlined,
    text: '固件管理',
    route: ERouterName.FIRMWARES
  },
  /* {
    key: 'menu',
    icon: MenuOutlined,
    text: '菜单管理',
    route: ERouterName.MENU
  }, */
  /* {
    key: 'logout',
    icon: ExportOutlined,
    text: '退出登录',
    isLogout: true
  }
  {
    key: 'dictionary',
    icon: ProfileOutlined,
    text: ERouterName.DICT_NAME,
    route: ERouterName.DICT
  },
  {
    key: 'third',
    icon: AppstoreAddOutlined,
    text: ERouterName.THIRD_APP_NAME,
    route: ERouterName.THIRD_APP
  },
  {
    key: 'menu',
    icon: MenuFoldOutlined,
    text: ERouterName.MENU_NAME,
    route: ERouterName.MENU
  },
  {
    key: 'role',
    icon: UsergroupAddOutlined,
    text: ERouterName.ROLE_NAME,
    route: ERouterName.ROLE
  }, */

]
